module.exports = __webpack_public_path__ + "img/shakespeare.f83a4019.jpg";